/* global onBeforeUnmount, nextTick */
// vue3-carousel toggles `aria-hidden` on slides (including its own internally
// generated `wrap-around` clone slides, which we never touch via v-for/:inert)
// but never manages focusability. This keeps `inert` in sync with `aria-hidden`
// for every `.carousel__slide`, clones included, fixing "ARIA hidden element
// must not be focusable or contain focusable elements".
export function useCarouselInert(carouselRef) {
  let observer

  function syncInert(el) {
    el.inert = el.getAttribute('aria-hidden') === 'true'
  }

  onMounted(() => {
    if (!import.meta.client)
      return

    nextTick(() => {
      const root = carouselRef.value?.$el
      if (!root)
        return

      root.querySelectorAll('.carousel__slide').forEach(syncInert)

      observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === 'attributes') {
            syncInert(mutation.target)
          }
          else if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === 1 && node.classList?.contains('carousel__slide'))
                syncInert(node)
            })
          }
        }
      })

      observer.observe(root, {
        attributes: true,
        attributeFilter: ['aria-hidden'],
        childList: true,
        subtree: true,
      })
    })
  })

  onBeforeUnmount(() => {
    observer?.disconnect()
  })
}
